import React, { KeyboardEventHandler } from "react";

import spinnerSvg from "../../assets/svg/spinner.svg";

export interface ButtonProps {
  onKeyDown?: KeyboardEventHandler<HTMLButtonElement> | undefined;
  onClick?: () => void;
  type?: "button" | "submit" | "reset" | undefined;
  backgroundColor?: string;
  hoverColor?: string;
  disabled?: boolean;
  outlineColor?: string;
  textSize?: string;
  pulsating?: boolean;
  loading?: boolean;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  width?: string;
  blackText?: boolean;
  stopPropagation?: boolean;
  squared?: boolean;
  height?: string;
  pxpy?: string;
  nominhfull?: boolean;
  notRounded?: boolean;
  roundedSize?: string;
  hoverFont?: string;
}

export const SolidButton: React.FC<ButtonProps> = ({
  onClick,
  type,
  children,
  backgroundColor,
  hoverColor,
  disabled,
  textSize,
  pulsating,
  loading,
  width,
  blackText,
  stopPropagation,
  squared,
  height,
  pxpy,
  nominhfull,
  notRounded,
}) => {
  if (!backgroundColor && !hoverColor) {
    backgroundColor = "bg-blue-600";
    hoverColor = "hover:bg-blue-700";
  }
  if (!pxpy) {
    pxpy = "px-3 md:px-4 py-3";
  }

  return (
    <button
      onMouseDown={stopPropagation ? (e) => e.stopPropagation() : undefined}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${pxpy} ${
        blackText ? "text-slate-800" : "text-white"
      } font-bold ${backgroundColor} ${hoverColor} ${
        textSize ? textSize : "text-sm"
      } ${width} ${height} shadow-lg hover:shadow-sm transition duration-500 ease-in-out ${
        nominhfull ? "" : "min-h-full"
      } ${squared ? "rounded-lg" : "rounded-xl"} ${
        notRounded ? "rounded-none" : ""
      } whitespace-nowrap ${pulsating ? "animate-pulse" : ""}`}
    >
      <div className="flex items-center justify-center">
        {loading ? (
          <div
            className={`flex items-center justify-center ${
              nominhfull ? "" : "min-h-full"
            }`}
          >
            <img
              className="h-5 animate-spin"
              src={spinnerSvg}
              alt="loading spinner"
            />
          </div>
        ) : (
          children
        )}
      </div>
    </button>
  );
};
